<template>
  <BInputGroup>
    <BFormSelect ref="select"
                 v-bind="$attrs"
                 :size="small ? 'sm' : undefined"
                 :class="{ 'ps-1': small }"
                 :model-value="value"
                 :options="options"
                 :value-field="valueField"
                 :text-field="textField"
                 @update:model-value="onInput">
      <option v-if="placeholder" :value="null" selected disabled hidden>{{ placeholder }}</option>
    </BFormSelect>
    <template #append>
      <BButton ref="clearButton"
               :size="small ? 'sm' : undefined"
               :variant="value ? 'primary' : 'outline-secondary'"
               :disabled="!value"
               @click="clearValue">
        <font-awesome-icon icon="times" />
      </BButton>
    </template>
  </BInputGroup>
</template>

<script>
export default {
  name: "SearchSelect",

  emits: ['input', 'change'],

  props: {
    value: { default: null },
    options: { type: Array, default: () => [] },
    valueField: { type: String, default: 'value' },
    textField: { type: String, default: 'text' },
    small: { type: Boolean, default: false },
    placeholder: { type: String }
  },

  methods: {
    // Fire input event
    onInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    },

    // Clears the current value
    clearValue() {
      this.$emit('input', null);
      this.$emit('change', null);
    }
  }
}
</script>

<style>
</style>
